import VueRouter from "vue-router";
// import { PlasmicComponent } from "@plasmicapp/loader-vue";

import Home from "../views/Home";
import Books from "../views/Books";
import Parts from "../views/Parts";
import Notes from "../views/Notes";
import Busses from "../views/Busses";
import Claims from "../views/Claims";
import Service from "../views/Service";
import History from "../views/History";
// import { PLASMIC } from "../plasmic-init";

// const CatchAllPage = {
//   components: { PlasmicComponent },
//   data() {
//     return {
//       loading: true,
//       pageData: null,
//       pathname: location.pathname.replace("/c", ""),
//     };
//   },
//   created() {
//     this.fetchData();
//   },
//   render() {
//     if (this.loading) {
//       return <div>Loading...</div>;
//     }
//     if (!this.pageData) {
//       return <div>Not found</div>;
//     }
//     return <PlasmicComponent component={this.pathname} />;
//   },
//   methods: {
//     async fetchData() {
//       const pageData = await PLASMIC.maybeFetchComponentData(this.pathname);
//       this.pageData = pageData;
//       this.loading = false;
//     },
//   },
// };

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    icon: "mdi-home",
    isPublic: true,
  },
  { path: "/busses", name: "Busses", component: Busses, icon: "mdi-bus-side" },
  { path: "/notes", name: "Notes", component: Notes, icon: "mdi-message-text" },
  {
    path: "/service",
    name: "Service",
    component: Service,
    icon: "mdi-progress-wrench",
  },
  {
    path: "/history",
    name: "VehicleTreatmentHistory",
    component: History,
    icon: "mdi-car-wrench",
  },
  { path: "/claims", name: "Claims", component: Claims, icon: "mdi-gavel" },
  {
    path: "/parts",
    name: "Parts",
    component: Parts,
    icon: "mdi-engine-outline",
    isPublic: true,
  },
  {
    path: "/books",
    name: "Books",
    component: Books,
    icon: "mdi-bookshelf",
    isPublic: true,
    children: [
      {
        path: "/books/driver",
        name: "Driver",
        component: Books,
        meta: { cat: 1 },
        isPublic: true,
      },
      { path: "/books/tech", name: "Tech", component: Books, meta: { cat: 2 } },
      { path: "/books/erp", name: "ERP", component: Books, meta: { cat: 3 } },
      {
        path: "/books/parts",
        name: "Parts2",
        component: Books,
        meta: { cat: 4 },
      },
      {
        path: "/books/claims",
        name: "Claims2",
        component: Books,
        meta: { cat: 5 },
      },
    ],
  },
  // {
  //   path: "/c/:pathMatch(.*)*",
  //   component: CatchAllPage,
  // },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
